enum SnapchatPixelEventsEnum {
  PAGE_VIEW = "PAGE_VIEW",
  ADD_ITEM_TO_CART = "ADD_CART",
}

export default SnapchatPixelEventsEnum;
